// extracted by mini-css-extract-plugin
export var logoMainContainer = "logo-module--logoMainContainer--3srw7";
export var item1 = "logo-module--item1--GYUL6";
export var logoSecondLineContainer = "logo-module--logoSecondLineContainer--fuQjm";
export var logoImage = "logo-module--logoImage--E6b5d";